import '@first-lego-league/user-interface/current/app.js'

import React from 'react'
import ReactDOM from 'react-dom'

import App from './app.jsx'

import './main.css'

ReactDOM.render(<App />, document.getElementById('root'))
